export const loginRoute = '/login'
export const oidcCallbackRoute = '/login/oidc/callback'
export const resetRoute = '/resetPassword'
export const forgotRoute = '/forgotPassword'
